<template>
  <div class="preset-index">
    <NoticeList />
  </div>
</template>

<script setup>
import NoticeList from './NoticeList.vue';
</script>

<style scoped>
.preset-index {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
</style>
